// Shared hostnames whose CDN77 aggregate stats cannot be attributed to a
// single account, so the CDN Usage card is hidden. Only applies to the legacy
// CDN77-only stats path: once the backend reports per-subscription usage
// (response source === 'cloudflare', or 'both' when the account also has a
// dedicated CDN77 resource summed in) the card is shown regardless of this
// list.
export const notAllowedCDNs: Array<string> = ["cdn.filespin.io","videocdn.filespin.io"];
